import React from 'react';
import { Modal, Button, Alert, Table } from 'react-bootstrap';
import { formatCurrency, formatDate } from '../../../../utils/formatters';
import { MAX_CARES_GRANTS, MAX_CARES_AMOUNT } from '../../../../constants/constants';

const CaresExceptionModal = ({ show, onYes, onNo, pledgesApplied, totalApplied }) => {
  return (
    <Modal show={show} onHide={onNo} centered>
      <Modal.Header className="bg-warning-subtle">
        <Modal.Title>CARES Grant Limit Reached</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning">
          <strong>This customer has reached the CARES Grant limit for this program year.</strong>
          <ul className="mb-0">
            <li>{pledgesApplied?.length} Grant applied out of {MAX_CARES_GRANTS} allowed.</li>
            <li>{formatCurrency(totalApplied)} applied out of max {formatCurrency(MAX_CARES_AMOUNT)} allowed.</li>
          </ul>
        </Alert>
        <Table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {pledgesApplied && pledgesApplied.map((pledge, index) => (
              <tr key={index}>
                <td>{formatDate(pledge?.appliedDate)}</td>
                <td>{formatCurrency(pledge?.pledgeAmount, '-')}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <p>Would you like to submit an exception request for an additional CARES grant?</p>
        <p className="text-muted small">
          Exception requests require approval and must include a reason for the exception.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onNo}>
          No, Cancel
        </Button>
        <Button variant="warning" onClick={onYes}>
          Yes, Request Exception
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CaresExceptionModal;